/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Polish language
 *
 * @file pl.js
 * @author Manimaran.S
 */

const pl = {
  'popularChannelSlider.allChannels': 'Wszystkie kanały',
  'popularChannelSlider.recommended': 'Zalecane',
  'hero.myetextbook.link': 'biblioteka',
  'hero.myetextbook.text': 'Niewłaściwy tytuł? Uzyskaj dostęp do eTextbook',
  'hero.etextfeaturestitle': 'Znajdź materiały do nauki w eTextbook',
  'hero.etextfeaturesdescription': 'Twój eTextbook zawiera materiały do nauki, które pomogą Ci odnieść sukces. Ucz się za pomocą fiszek i innych materiałów dostępnych bezpośrednio w Twoim eTextbook.',
  'aichat.title1': 'Uzyskaj pomoc opartą na sztucznej inteligencji we wszystkich kwestiach związanych z eTextbook.',
  'aichat.chatDesc1': 'Wpisz pytanie, aby rozpocząć',
  'subscriptiontext.isSubscribed': 'Część Twojej subskrypcji',
  'subscriptiontext.nonSubscriber': 'Zaktualizuj, aby uzyskać pełny dostęp',
  'topicConatiner.otherHeader': '-',
  'topicConatiner.exactLiteHeader': '-',
  'moremenu.downloadApp': '-',
  'moremenu.downloadAppAlreadyDownload': '%Click here%, aby pobrać aplikację na inne urządzenie i zalogować się automatycznie lub użyć unikalnego kodu QR do bezpiecznego zalogowania się w aplikacji, którą już zainstalowałeś.',
  'moremenu.downloadAppNotDownload': '%Click here%, aby pobrać aplikację i bezpiecznie zalogować się za pomocą unikalnego kodu QR.',
  'channel.noBundletitle': 'Skorzystaj z Przygotowania do nauki dla powiązanych i innych kursów',
  'onboard.studyPlan': 'Utworzono indywidualny plan nauki!',
  'onboard.addCourseAnother': 'Czy chcesz dodać kolejny kurs?',
  'onboard.purchase': 'Muszę kupić e-Textbook Pearson',
  'onboard.addCourseWithoutEtext': 'Dodaj kurs za pomocą Przygotowania do nauki',
  'onboard.mayBeLater': 'Może później',
  'onboard.aboutCourse': 'Opowiedz nam o swoim kursie',
  'onboard.close': 'Zamknij',
  'course.addTitle': 'Dodaj kurs',
  'common.PURCHASE': 'Zakup',
  'common.CLOSE': 'Zamknij',
  'open': 'otwórz',
  'continue': 'Kontynuuj',
  'yes': 'Tak',
  'no': 'Nie',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Sukces!',
  'courses.toc.PUBLISH_MESSAGE': 'Studenci zobaczą Twoje zmiany, gdy następnym razem otworzą treść.',
  'errors.GENERIC_TITLE': '-',
  'errors.GENERIC_DESC': '-',
  'errors.GENERIC_LINK': '-',
  'errors.GENERIC_CODE': '-',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Nie znaleziono subskrypcji',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Twoje konto nie obejmuje dostępu do tego tytułu. Jeśli uważasz, \n    że otrzymałeś ten komunikat przez pomyłkę, skontaktuj się z pomocą techniczną Pearson',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Nie znaleziono subskrypcji',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Twoja subskrypcja nie obejmuje dostępu do aplikacji eText, \n    jednak możesz ją teraz zasubskrybować za pomocą karty kredytowej.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Moje konto',
  'menu.helpCenter': 'Centrum pomocy',
  'menu.preferencesCenter': 'Centrum preferencji',
  'menu.CONTACT_SUPPORT': 'Kontakt z pomocą techniczną',
  'menu.HELP_SUPPORT': 'Pomoc i wsparcie',
  'menu.FAQS': 'Często zadawane pytania',
  'menu.CHAT_WITH_SUPPORT': 'Czat z pomocą techniczną',
  'menu.OTP_CODES': 'Kody OTP',
  'menu.LAUNCH_CODE': 'Uruchom dziennik kodów',
  'menu.SEND_CODE': 'Wyślij nowy kod użytkownika przez e-mail',
  'menu.SEND_CODE_PHONE': 'Wyślij nowy kod użytkownika przez wiadomość SMS',
  'menu.LEGAL': 'Prawne',
  'menu.PRIVACY_NOTICE': 'Informacja o prywatności',
  'menu.TITLE_INFO': 'Informacja tytułowa',
  'menu.PEARSON_ACCESSIBILITY': 'Dostępność Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Zarejestruj {deviceLimit} urządzenia. Wymieniaj 1 raz w miesiącu.',
  'menu.ACCESSIBILITY': 'Dostępność',
  'menu.ACCESSIBILITY_SUPPORT': 'Wsparcie dostępności',
  'menu.DEVICES': 'Ostatnie urządzenia',
  'menu.THIS_DEVICE': 'To urządzenie',
  'menu.GET_THE_APP_DOWNLOAD': 'Pobierz aplikację mobilną',
  'menu.MOJO_APP_INFO': 'Aby korzystać z Pearson+ w trybie offline, przejdź do sklepu z aplikacjami na swoim telefonie lub tablecie.',
  'menu.DEVICE_LABEL': 'Urządzenie',
  'menu.DEVICE_DISCONNECT': 'Rozłącz',
  'menu.FOXIT': 'Obsługiwane przez Foxit',
  'menu.TERMS_OF_USE': 'Warunki korzystania',
  'menu.SIGN_OUT': 'Wyloguj',
  'menu.PRINT_PAGE': 'Drukuj stronę',
  'menu.COPY_RIGHT': 'Prawo autorskie © {year} Pearson Education Inc. Wszystkie prawa zastrzeżone.',
  'print.FOOTER_MESSAGE': 'Wydrukowano {fullName}({email}) w dniu {currentDate}.',
  'print.WATERMARK': '-',
  'device.SWAPPED_ALREADY': 'W tym miesiącu już dokonałeś zamiany',
  'device.SWITCH_DEVICE': 'Przełączyć się na bieżące urządzenie?',
  'device.SWITCH_ONCE': 'Ponieważ możesz się przełączyć tylko raz w miesiącu, nie będziesz mógł się cofnąć.',
  'device.SEAT_TAKEN': 'To miejsce jest zajęte',
  'device.DISCONNECT_DEVICE': 'Możesz zalogować się tylko na 3 urządzeniach. Aby kontynuować, odłącz kolejne urządzenie.',
  'device.ALERT_TEXT': 'Pamiętaj, że możesz zmieniać urządzenia tylko raz w miesiącu.',
  'device.DISCONNECT': 'Rozłącz',
  'device.CONTINUE': 'Kontynuuj',
  'device.HEADER': 'Czy zakończyć sesję w innej przeglądarce?',
  'device.CLOSE': 'Powrót do strony głównej',
  'device.CODE': '-',
  'device.TIMER': 'Masz {time}, aby wprowadzić swój kod tutaj',
  'device.RESEND': '-',
  'device.FAQ': '-',
  'device.RESEND_NAME': 'Wyślij ponownie',
  'device.NOTE': '-',
  'device.NOTE_HEADER': '-',
  'device.CONTACT_SUPPORT': 'pomoc techniczna',
  'device.CONTACT_EMAIL': 'zaktualizuj adres e-mail',
  'device.INCORRECT': 'Nieprawidłowy - sprawdź ponownie swój kod lub wyślij go ponownie.',
  'device.MANY_ATTEMPTS': 'Zbyt wiele prób, spróbuj wysłać kod ponownie',
  'device.EXPIRED': 'Czas minął, spróbuj wysłać kod ponownie',
  'device.ACCESS_HEADER': 'Jesteś zalogowany!',
  'device.ACCESS_DESC': 'Twoja sesja została uwierzytelniona. Chcesz w tym czasie zaktualizować swoje hasło?',
  'device.ACCESS_CHANGE_PASSWORD': 'Zmień hasło',
  'device.ACCESS_RESET_PASSWORD': 'Zresetuj hasło',
  'device.THREATONE_TITLE': 'Wszystko OK?',
  'device.THREATONE_DESC': 'Zauważyliśmy podejrzaną aktywność na Twoim koncie.',
  'device.THREATONE_DESC_TWO': 'To dobry moment na zmianę hasła.',
  'device.MAY_BE_LATER': 'Może później',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': 'Aby zapewnić bezpieczeństwo, wylogowaliśmy Cię. Wysłaliśmy link resetujący hasło na adres e-mail przypisany do Twojego konta.',
  'device.ACCOUNT_LOCK_TITLE': 'Zauważyliśmy podejrzaną aktywność na Twoim koncie',
  'device.ACCOUNT_LOCK_TIMER': 'Zostaniesz wylogowany za {time}',
  'navigation.PAGE': 'Strona',
  'launchcode.CREATEBY': 'Utworzony przez:',
  'launchcode.sentvia': 'Wysłany za pomocą:',
  'launchcode.CODEINLAST': 'Kody z ostatnich 7 dni:',
  'launchcode.TIMESENT': 'Godzina wysyłki:',
  'launchcode.ACCOUNTEMAIL': 'Adres e-mail klienta:',
  'launchcode.LAUNCHDIALOGTITLE': 'Dziennik kodów OTP',
  'textmessage.TITLE': 'Wprowadź numer telefonu',
  'textmessage.PHONE_NUMBER': 'Numer telefonu',
  'textmessage.SEND_CODE': 'Wyślij kod',
  'textmessage.INVALID_NUMBER': 'Nieprawidłowy numer telefonu komórkowego.',
  'textmessage.SUCCESS_MESSAGE': 'Kod został wysłany',
  'remove.title': 'Usunąć tytuł?',
  'remove.subTitle': 'Zawsze możesz odzyskać go później - wystarczy użyć wyszukiwania, aby ponownie go dodać.',
  'remove.buttonText': 'Usuń',
  'search.searchPlaceHolderPPlus': 'Wyszukaj według ISBN, tytułu lub autora',
  'search.searchPlaceHolderEText': 'Przeszukaj swoją bibliotekę',
  'footer.downloadMobileApp': 'Pobierz aplikację mobilną',
  'footer.termsOfUse': 'Warunki korzystania',
  'footer.privacy': 'Prywatność',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Nie sprzedawaj moich danych osobowych',
  'footer.accessibility': 'Dostępność',
  'footer.patentNotice': 'Informacja o patencie',
  'footer.copyrights': 'Pearson Wszystkie prawa zastrzeżone.',
  'hero.toc.defaultPlacehoder': '-',
  'hero.openEtextBookV1': 'Otwórz podręcznik eText',
  'hero.heroHeading': 'Poniewać uczysz się <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Przygotowanie do nauki',
  'hero.study.help': 'Uzyskaj pomoc w nauce',
  'hero.study.jumpBackIn': 'Wróć do gry',
  'hero.study.numOfUsers': 'Obecnie z kanałów korzysta <b>{num_of_users}</b> studentów.',
  'hero.heroChannel.cardsHeading': 'Kontynuuj tam, gdzie przerwałeś',
  'hero.marketingcard1.copy.title': 'Ucz się z pomocą filmów',
  'hero.marketingcard1.copy.description': 'Obejrzyj objaśnienia wideo, które wyjaśniają trudne tematy.',
  'hero.marketingcard2.copy.title': 'Problemy w praktyce',
  'hero.marketingcard2.copy.description': 'Przygotuj się do egzaminu z tysiącami pytań egzaminacyjnych i rozwiązań wideo',
  'hero.marketingcard3.copy.title': 'Uzyskaj doświadczoną pomoc',
  'hero.marketingcard3.copy.description': 'Zadawaj pytania i otrzymuj odpowiedzi od ekspertów w danej dziedzinie.',
  'hero.popularTopics.heading': 'Inne popularne tematy na tym kanale',
  'hero.popularChannels.headingv1': 'Bierzesz udział w kolejnym kursie?',
  'hero.popularChannels.descriptionv2': 'Przeglądaj popularne tematy pomocy w nauce.',
  'hero.practice': 'Przećwicz',
  'hero.herobook.mappedChannelHeading': 'Polecana pomoc w nauce na tym kanale',
  'libraryL2.myBooks': '-',
  'libraryL2.archived': 'Dodany do archiwum',
  'libraryL2.back': 'Wróć',
  'hero.practiceProblem': '-',
  'nativeAppBanner.drawer.title': '-',
  'nativeAppBanner.drawer.pearsonApp': '-',
  'nativeAppBanner.banner.title': '-',
  'nativeAppBanner.banner.description': '-',
  'hero.promotionalcard.list1': 'Krótkie filmy, które wyjaśniają trudne tematy',
  'hero.promotionalcard.list2': 'Tysiące pytań egzaminacyjnych',
  'hero.promotionalcard.list3': 'Otrzymuj odpowiedzi od ekspertów w danej dziedzinie',
  'hero.studyandexamprep': 'Przygotowanie do nauki',
  'hero.heroBook.sectionSubHeadingV1': 'Zgłębiaj trudne tematy dzięki objaśnieniom w formie filmików wideo i pytaniom praktycznym dostosowanym do Twojego kursu.',
  'hero.heroBook.sectionSubHeadingV2': 'Zgłębiaj trudne tematy dzięki objaśnieniom pojęć i pytaniom praktycznym dostosowanym do Twojego kursu.',
  'hero.SeeAllStudyOptions': '-',
  'hero.herobook.mappedChannelHeadingV1': '-',
  'hero.popularTopics.headingV1': 'Inne popularne tematy',
  'hero.heroHeadingV1': '-',
  'hero.learnmore': 'Dowiedz się więcej',
  'hero.eTextbook': 'Podręcznik eText',
  'hero.goToPage.label': 'Przejdź do strony',
  'subscription.studyTitle': 'Przygotowanie do nauki',
  'print.printAvailTitle': 'Chcesz wydrukować tę stronę? Oto jak',
  'print.printAvailDesc': 'W eTexbook wybierz ikonę konta w prawym górnym rogu. W opcjach wybierz „Drukuj stronę”, a następnie wybierz ustawienia drukowania.',
  'print.printNotAvailTitle': '-',
  'print.printNotAvailDesc': '-',
  'hero.header.cta': '-',
  'hero.header.ctav2': 'Otwórz Przygotowanie do nauki',
  'hero.marketing.title': 'Znajdź swój podręcznik eText',
  'hero.marketing.subTitle': 'Wybieraj spośród ponad 2000 podręczników e-Text z dźwiękiem, fiszkami, notatkami i nie tylko. Tylko 10,99 USD miesięcznie za 4-miesięczny okres.',
  'hero.popularchannels.desc': 'Uzyskaj pomoc w nauce tych najważniejszych przedmiotów',
  'hero.removecourse.title': 'Usunąć kurs z pulpitu nawigacyjnego?',
  'hero.removecourse.description': 'Zawsze możesz dodać ten kurs z powrotem do pulpitu nawigacyjnego, klikając „Dodaj kurs”',
  'hero.removecourse.primaryCtaText': 'Usuń',
  'hero.removecourse.secondaryCtaText': 'Anuluj',
  'hero.tableOfContents': 'Spis treści',
  'hero.search': 'Wyszukaj',
  'hero.emptystate.cta': 'Wyszukaj elementy eTextbook',
  'hero.watch_it_again': 'Obejrzyj ponownie',
  'hero.mondly.learnLang.title': 'Naucz się nowego języka za darmo',
  'hero.mondly.subTitle': 'Użytkownicy eTextbook Pearson otrzymują trzy bezpłatne miesiące Mondly by Pearson.',
  'hero.mondly.description': 'Większość aplikacji do nauki języków obcych pozwala uczyć się tylko z poziomu języka angielskiego. Najlepiej jest jednak uczyć się w swoim ojczystym języku, więc Mondly umożliwia naukę w dowolnym z 41 języków.',
  'hero.mondly.startLearningCTA': 'Rozpocznij naukę',
  'hero.mondly.marketing.bestApp': '-',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': '-',
  'hero.mondly.marketing.fbStart': '-',
  'hero.mondly.marketing.editorChoice': '-',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Naucz się języka',
  'header.menu.moreAtPearson': 'Więcej na stronie Pearson',
  'hero.subscriptionStatusTitle2': 'Twoje zasoby Pearson+',
  'hero.startStudying': 'Rozpocznij naukę',
  'onboard.studyMaterials': 'Wybierz swój przedmiot, a my stworzymy pulpit nawigacyjny ze spersonalizowanymi materiałami do nauki.',
  'hero.myETextbooks': 'Moje podręczniki eText',
  'header.continueInTheApp': 'Kontynuuj w aplikacji',
  'hero.learnTxt': 'Ucz się',
  'hero.examPrepTxt': 'Przygotowanie do egzaminu',
  'hero.aITutorTxt': 'Nauczyciel AI',
  'AI.toolTip': 'Zapytaj mnie o swój eTextbook',
  'hero.studyExamPrepAllYourCourses': 'Przygotowanie do nauki dla wszystkich Twoich kursów',
  'header.qrCode.subHeaderTxt': 'Użyj tego kodu QR, aby szybko i bezpiecznie zalogować się do aplikacji Pearson+ na urządzeniu mobilnym.',
  'header.qrCode.dontHaveApp': 'Nie masz aplikacji?',
  'header.qrCode.footerTxt': 'Zeskanowanie tego kodu spowoduje przekierowanie do sklepu App Store lub Google Play. Po pobraniu aplikacji zaloguj się, skanując ponownie kod.',
  'header.qrCode.errorMsg': 'Kod QR nie został załadowany. Zamknij i spróbuj ponownie',
  'hero.yourETextbook': 'Twój podręcznik eText',
  'onboard.addCourseWithEtextBundle': 'Dodaj kurs za pomocą Przygotowania do nauki',
  'onboard.disableTooltipText': 'Dodano wszystkie kursy związane z Przygotowaniem do nauki!',
  'subscriptionstatus.bundlecta': 'Uzyskaj dostęp do Przygotowania do nauki',
  'subscriptionstatus.nonbundlecta': 'Uzyskaj dostęp do Przygotowania do nauki',
  'channel.genericBundle': 'Wykorzystaj Przygotowanie do nauki dla potrzeb innych kursów',
  'channel.relatedBundle': 'Wykorzystaj też Przygotowanie do nauki dla potrzeb innych kursów',
  'onboard.courseAdded': 'Kurs dodany!',
  'hero.flashcards': 'Fiszki',
  'relatedChannelCard.title': 'Wzbogać swoją wiedzę dzięki tym powiązanym zasobom',
  'relatedChannelCard.badgeText': 'Powiązane zasoby Przygotowania do nauki',
  'sessionInactivity.title': 'Wciąż tam jesteś?',
  'sessionInactivity.description': '-',
  'sessionInactivity.keepMeSignIn': 'Nie pozwól mi się wylogować',
  'sessionInactivity.signOut': 'Wyloguj',
  'sessionTimeout.title': 'Sesja wygasła',
  'sessionTimeout.description': 'Twoja sesja wygasła z powodu braku aktywności.',
  'print.qrCode.header': 'Użyj tego kodu QR, aby szybko i bezpiecznie otworzyć aplikację Pearson+ na urządzeniu mobilnym.',
  'print.qrCode.footer': 'Zeskanowanie tego kodu spowoduje przekierowanie do sklepu App Store lub Google Play. Po zainstalowaniu aplikacji zaloguj się, aby pobrać i uzyskać dostęp do swojego tytułu.',
  'hero.nestest.title': '-',
  'hero.nestest.subTitle': '-',
  'hero.channelAI.title': 'Potrzebujesz pomocy? Nauczyciel AI ma wszystko pod kontrolą.',
  'hero.channelAI.desc': 'Zadaj pytanie i otrzymaj szczegółową pomoc w odrabianiu zadań domowych, zalecenia dotyczące nauki i wiele więcej — spersonalizowaną pomoc uzyskasz zawsze, gdy jej potrzebujesz.',
  'hero.channelAI.action': 'Już teraz zadaj pytanie nauczycielowi AI',
  'new': 'Nowość!',
  'hero.practice.numOfUsers': '-',
  'hero.practice.cta': '-',
  'hero.practice.title': '-',
  'diagnostics.errorMsg': 'Diagnostyka nie została załadowana. Zamknij i spróbuj ponownie',
  'qrcode.title': '-',
  'qrcode.subtitle': '-',
  'qrcode.detailsv1': '-',
  'qrcode.detailsv2': '-',
  'qrcode.details': '-',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': '-',
  'install': 'Install',
  'header.menu.createCourse': 'Nowy kurs',
  'header.dropdown.courses': 'Kursy',
  'header.dropdown.recentlyViewed': 'Ostatnio przeglądane',
  'header.dropdown.viewAll': 'Zobacz wszystkie kursy',
  'aet.courseHeader.inviteStudents': 'Zaproś studentów',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Zachęć studentów do skorzystania z tego e-Textbooka, kopiując poniższy adres linku lub instrukcje do wiadomości e-mail lub do programu zajęć.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Adres łącza',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Kopiuj link',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instrukcje z adresem łącza',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Kopiuj instrukcje',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Zostaniesz poproszony o zalogowanie się przy użyciu swojego istniejącego konta Pearson. Jeśli nie masz konta Pearson, będziesz mógł je założyć.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Data rozpoczęcia:',
  'aet.courseHeader.endDate': 'Data zakończenia:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Zarządzaj listą',
  'aet.home.managegradesync': 'Zarządzaj synchronizacją ocen',
  'aet.home.copycourse': 'Kopiuj kurs',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Bieżący',
  'aet.instructorCourse.tabs.past': 'Przeszłe',
  'aet.instructorCourse.tabs.courseSettings': 'Ustawienia kursu',
  'aet.instructorCourse.tabs.manageRoster': 'Zarządzaj listą',
  'aet.instructorCourse.currentCourses.title': 'Bieżące kursy',
  'aet.instructorCourse.pastCourses.title': 'Poprzednie kursy',
  'aet.instructorCourse.createOrCopy.title': 'Utwórz lub kopiuj kurs',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Skopiuj kurs innego prowadzącego lub utwórz nowy',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Skopiuj kurs innego prowadzącego',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Wpisz ID kursu, aby znaleźć kurs, który chcesz skopiować.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID kursu',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Wpisz ID kursu',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Szukałeś',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Utwórz nowy kurs z katalogu',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Wyszukaj według tytułu, autora, numeru ISBN lub słów kluczowych związanych z tematyką.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Wyszukaj...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Pokaż więcej',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Pokaż mniej',
  'aet.instructorCourse.cancel': 'Anuluj',
  'aet.instructorCourse.loading': 'Ładowanie...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Synchronizacja ocen',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Zarządzaj synchronizacją ocen',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nazwa kursu',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Bez tytułu',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nazwa sekcji',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Bez tytułu',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Instytucja',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Instytucja jest wymagana',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Coś poszło nie tak. Spróbuj ponownie.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Brak wyników',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Data rozpoczęcia kursu',
  'aet.instructorCourse.courseForm.endDateLabel': 'Data zakończenia kursu',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/rr',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Zezwól innym na skopiowanie tego kursu',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Udostępnij ten kod instruktorom, którzy chcą skopiować ten kurs',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Kopiuj kod',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opcjonalnie)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'W formularzu występują błędy walidacji',
  'aet.instructorCourse.courseForm.submitContinue': 'Kontynuuj',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Zapisywanie...',
  'aet.instructorCourse.courseForm.submitError': 'Nie udało nam się utworzyć twojego kursu. Spróbuj ponownie.',
  'aet.instructorCourse.courseForm.submitEditError': 'Nie udało nam się zapisać wprowadzonych zmian. Spróbuj ponownie.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Zapisz zmiany',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materiały szkoleniowe',
  'aet.instructorCourse.courseForm.resolveError': 'Nie udało nam się załadować materiałów szkoleniowych. Spróbuj ponownie.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Ostatnio przeglądane',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Ostatnio dodane',
  'aet.instructorCourse.coursesSort.aToZ': 'A do Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z do A',
  'aet.instructorCourse.manageRoster.column.name': 'Nazwa',
  'aet.instructorCourse.manageRoster.column.role': 'Rola',
  'aet.instructorCourse.manageRoster.column.email': 'E-mail',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Student',
  'aet.instructorCourse.roster.role.ta': 'Asystent Dydaktyczny',
  'aet.instructorCourse.roster.role.instructor': 'Instruktor',
  'aet.instructorCourse.roster.status.active': 'Aktywny',
  'aet.instructorCourse.roster.status.inactive': 'Nieaktywny',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Wszyscy członkowie',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Aktywni studenci',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Nieaktywni studenci',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Asystent dydaktyczny',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instruktor',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autor:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Data utworzenia kursu:',
  'aet.instructorCourse.noCoursesFound': 'Nie znaleziono kursów',
  'aet.instructorCourse.backButton': 'Wróć',
  'aet.instructorCourse.selectCourse': 'Wybierz kurs',
  'aet.home.linkedToLms': 'Powiązano z LMS',
  'aet.instructorCourse.courseForm.title.create': 'Utwórz kurs',
  'aet.instructorCourse.courseForm.title.copy': 'Kopiuj kurs',
  'aet.instructorCourse.courseForm.title.edit': 'Informacje o kursie',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Zadania',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Elementy zadania',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Terminy oddania zadań',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Podkreślenia i notatki',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Kolor podkreślenia',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Zanotuj tekst',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Wspólny status',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Lista i zaangażowanie studentów',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Nazwiska studentów',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Adresy e-mail',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Rejestracje',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Zakończenie i wnioski',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Ustawienia',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Skopiowane dane',
  'aet.studentRoster.manageStudentRosterButton': 'Zarządzaj listą studentów',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Eksportuj postęp studentów',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Zarejestrowany:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Rola:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Jako asystent dydaktyczny osoba ta będzie mogła śledzić postępy i wyniki wszystkich studentów w tej grupie.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Będzie również mogła zarządzać studentami i zadaniami, jednak nie będzie mogła usunąć zajęć.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promuj na asystenta dydaktycznego',
  'aet.home.manageRoster.searchPlaceholder': 'Wyszukaj studenta',
  'aet.home.manageRoster.inactivateButtonLabel': 'Deaktywuj wybranych studentów',
  'aet.home.manageRoster.FilterLabel': 'Pokaż',
  'aet.home.manageRoster.updatingMessage': 'Aktualizowanie listy... Może potrwać kilka minut.',
  'aet.home.courses.search.searchPlaceHolder': 'Wyszukaj swoje kursy',
  'aet.courses.emptyStateDescription': 'Zacznij tworzyć swój kurs, wybierając jedną z poniższych opcji.',
  'nativePromoBanner.continueInBrowser': '-',
  'globalnav.tooltip.hideNavText': '-',
  'globalnav.tooltip.showNavText': '-',
  'aet.syllabus.progressTitle': 'Wyodrębnianie...',
  'aet.syllabus.progressDesc': 'Proszę czekać, aż przetworzymy Twój sylabus.',
  'aet.syllabus.uploadInputLabel': 'Przeciągnij i upuść pliki lub kliknij, aby je przesłać',
  'aet.syllabus.uploadSyllabusTabLabel': 'Prześlij sylabus',
  'aet.syllabus.dateAdjusterTabLabel': 'Regulator daty',
  'aet.syllabus.addManuallyTabLabel': 'Dodaj ręcznie',
  'aet.syllabus.addEditLaterText': 'Zadania można zawsze dodać i edytować później',
  'aet.syllabus.editAssignmentLabel': 'Edytuj zadanie',
  'aet.syllabus.addAssignmentLabel': 'Dodaj zadanie',
  'aet.syllabus.assignmentTitleLabel': 'Tytuł zadania',
  'aet.syllabus.dueDateLabel': 'Termin',
  'aet.syllabus.editDueDateLabel': '-',
  'aet.syllabus.chaptersCoveredLabel': 'Wybierz rozdziały lub sekcje do nauki.',
  'aet.syllabus.updateCtaLabel': 'Aktualizuj zadanie',
  'aet.syllabus.addCtaLabel': 'Dodaj zadanie',
  'aet.syllabus.uploadLabel': 'Prześlij',
  'aet.syllabus.confirmLabel': 'Potwierdź',
  'aet.syllabus.updateDatesLabel': 'Data aktualizacji',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': 'Usunąć zadanie?',
  'aet.deleteAssignmentTitleMultiple': 'Usunąć zadania?',
  'aet.deleteAssignmentWarning': 'Czynności tej nie można cofnąć, a wszystkie powiązane materiały i dane studentów nie będą już widoczne.',
  'aet.deleteAssignmentKeepCTA': 'Zachowaj zadanie',
  'aet.deleteAssignmentDeleteCTA': 'Usuń',
  'aet.assignments.loadingAsset': 'Ładowanie zasobu...',
  'aet.assignments.allCaughtUpDescription': 'W tym tygodniu nie masz żadnych zadań do wykonania.',
  'aet.assignments.progressTitle': 'Postęp',
  'aet.assignments.performanceTitle': 'Pewność',
  'aet.assignments.completionTitle': 'Realizacja',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Dodaj zadanie',
  'aet.assignments.deleteTooltip': 'Usuń wybrane zadania',
  'aet.assignments.selectToDeleteLabel': 'Tryb zaznaczania i usuwania',
  'aet.assignments.bulkEditTooltip': 'Edycja zbiorcza zadań',
  'aet.assignments.title': 'Zadania',
  'aet.assignments.assignmentTitle': 'Zadanie',
  'aet.assignments.dueDate': 'Termin',
  'aet.tabular.searchPlaceholder.assignments': '-',
  'aet.tabular.searchPlaceholder.students': '-',
  'aet.tabular.searchPlaceholder.questions': '-',
  'aet.assignemnts.columnDueDateInfoTooltip': '-',
  'aet.assignemnts.singleDueDateInfoTooltip': '-',
  'aet.assignemnts.masterDueDateInfoTooltip': '-',
  'aet.home.loading': 'Ładowanie...',
  'aet.home.errorFetchingAssignments': 'Błąd pobierania zadań',
  'aet.home.dueThisWeekTitle': 'Termin w tym tygodniu',
  'aet.home.allCaughtUpTitle': 'Wszystko już wiesz!',
  'aet.home.allCaughtUpDescription': 'W tym tygodniu nie masz żadnych zadań do wykonania.',
  'aet.home.suggestedRemediationTitle': '-',
  'aet.home.noSuggestedRemediationTitle': 'Brak sugerowanego materiału do powtórzenia',
  'aet.home.noSuggestedRemediationDescription': 'Sprawdź ponownie po wykonaniu następnego zadania.',
  'aet.home.assignmentIncludesTitle': 'Zadanie obejmuje',
  'aet.home.sectionsLabel': '-',
  'aet.home.questionsCount': '{count} pytania',
  'aet.home.dueLabel': '-',
  'aet.home.due': 'W terminie:',
  'aet.home.progressCompletedLabel': 'Ukończony',
  'aet.home.progressCompletedPastDueLabel': 'Ukończone zaległe',
  'aet.home.progressInProgressLabel': 'W trakcie',
  'aet.home.progressNotStartedLabel': 'Nierozpoczęte',
  'aet.home.progressCountOfTotal': '-',
  'aet.home.NotAttemptedLabel': 'Nie podjęto próby',
  'aet.home.questionsTotalLabel': 'Łączna liczba pytań',
  'aet.home.progressCompletedOnTimeLabel': 'Ukończone w terminie',
  'aet.home.segmentGreatLabel': 'Świetnie',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': 'Wymaga pracy',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': 'Edytuj zadanie',
  'aet.home.deleteAssignmentTooltip': 'Usuń zadanie',
  'aet.home.viewDetailsButton': 'Przeglądaj szczegóły',
  'aet.home.viewAsStudentButton': 'Przeglądaj jako student',
  'aet.home.welcomeButtonText': 'Zaczynamy →',
  'aet.review.emptyStateTitle': 'Nie masz niczego do powtórzenia',
  'aet.review.emptyStateDescription': 'Sprawdź ponownie po wykonaniu następnego zadania.',
  'aet.dashboard.tabs.upNext': 'Do góry',
  'aet.dashboard.tabs.welcome': 'Witamy',
  'aet.dashboard.tabs.assignments': 'Zadania',
  'aet.dashboard.tabs.review': 'Powtórzenie',
  'aet.dashboard.tabs.studentRoster': 'Studenci',
  'aet.dashboard.classSchedule': 'Harmonogram zajęć:',
  'aet.syllabus.dueTimeLabel': 'Termin',
  'hero.accessEducatorGuides': 'Uzyskaj dostęp do przewodników dla nauczycieli',
  'aet.assignment.save': 'Zapisz',
  'aet.assignment.saveAndAdd': 'Zapisz i dodaj kolejne',
  'aet.assignment.delete': 'Usuń',
  'aet.assignment.saveAndClose': 'Zapisz i zamknij',
  'aet.studentRoster.title': 'Studenci',
  'aet.studentRoster.titlev1': 'Student',
  'aet.studentRoster.dueDatesAdjustmentLabel': '-',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standardowa',
  'aet.studentRoster.dueDateAdjustment.option.2': '-',
  'aet.studentRoster.dueDateAdjustment.option.3': '-',
  'aet.studentRoster.dueDateAdjustment.option.5': '-',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '-',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '-',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': '-',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '-',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '-',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': '-',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': '-',
  'aet.bulkEdit.bulkSplitInstruction': 'Podzielimy Twoje zadania równo.',
  'aet.bulkEdit.Description': '-',
  'aet.bulkEdit.firstAssignmentDue': 'Pierwsze zadanie do oddania',
  'aet.bulkEdit.lastAssignmentDue': 'Ostatnie zadanie do oddania',
  'aet.bulkEdit.assignmentsDueDays': 'W jakie dni chcesz oddawać zadania?',
  'aet.bulkEdit.addEditLaterText': 'Wykorzystujemy sztuczną inteligencję do tworzenia zadań.Zadania można zawsze dodać i edytować później.',
  'aet.bulkEdit.monday': 'Poniedziałek',
  'aet.bulkEdit.tuesday': 'Wtorek',
  'aet.bulkEdit.wednesday': 'Środa',
  'aet.bulkEdit.thursday': 'Czwartek',
  'aet.bulkEdit.friday': 'Piątek',
  'aet.bulkEdit.saturday': 'Sobota',
  'aet.bulkEdit.sunday': 'Niedziela',
  'aet.toast.assignmentCreated.title': 'Utworzono zadanie!',
  'aet.toast.assignmentCreated.single': 'Zostało automatycznie nazwane {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} zadania zostały utworzone',
  'aet.toast.assignmentUpdated.title': '-',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} zostało zaktualizowane',
  'aet.toast.assignmentUpdated.multiple': '-',
  'aet.toast.viewAssignment': 'Przeglądaj zadanie',
  'aet.toast.viewAssignments': 'Przeglądaj zadania',
  'aet.welcome.title': 'Twój podręcznik eTextbook Pearson jest teraz połączony z kursem LMS',
  'aet.welcome.LMSAccounTitle': 'Poznaj spostrzeżenia',
  'aet.welcome.LMSAccounDescription': 'Zobacz dokładnie, z jakimi tematami Twoja klasa ma trudności.',
  'aet.welcome.createAssignmentsTitle': 'Utwórz zadania',
  'aet.welcome.createAssignmentsDescription': 'Przypisuj rozdziały ręcznie lub poprzez przesłanie programu nauczania.',
  'aet.welcome.progressViewTitle': 'Śledź wyniki w swoim LMS',
  'aet.welcome.progressViewDescription': 'Wybierz ustawienia synchronizacji ocen w kursie LMS',
  'aet.assignmentDetails.noAssignmentFound': 'Nie znaleziono zadania',
  'aet.assignments.loadingErrorTitle': 'Nie można teraz załadować zadania',
  'aet.assignments.loadingErrorDescription': 'Spróbuj odświeżyć lub sprawdź później.',
  'aet.assignmentStudentDetails.noDataFound': 'Nie ma jeszcze żadnych danych',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Nie ma zarejestrowanych studentów',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Studenci dołączą do Twoich zajęć po zakupie podręcznika eTextbook.',
  'aet.home.editAssignmentTooltipDisabled': 'Nie można edytować: praca ucznia w toku',
  'aet.home.deleteAssignmentTooltipDisabled': 'Nie można usunąć: praca ucznia w toku',
  'aet.home.StudentDetails.questions': 'Pytania',
  'aet.home.StudentDetails.attempts': 'Próby',
  'aet.home.StudentDetails.comprehension': 'Pewność',
  'hero.titleInfo.tooltip': 'Informacja tytułowa',
  'aet.home.publishAssignments': 'Opublikuj wszystkie zadania',
  'aet.dashboard.footer': 'Niektóre treści stworzone przy użyciu sztucznej inteligencji na podstawie materiałów edukacyjnych Pearson. Pearson dysponuje procesem walidacji danych wyjściowych, jednak generatywna sztuczna inteligencja może nadal generować niedokładne informacje o ludziach, miejscach lub faktach.',
  'aet.home.bulkEditTitle': 'Edytuj zadania zbiorczo',
  'aet.home.bulkEditSubtitle': 'Wprowadź zmiany w swoim sylabusie, a następnie ponownie prześlij go tutaj. Twoje zadania i terminy zostaną odpowiednio zaktualizowane.',
  'aet.home.createAssignmentTitle': 'Utwórz zadania',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Uwzględnione w innym zadaniu',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Niektóre sekcje zostały uwzględnione w innym zadaniu',
  'aet.welcome.welcome.Title': 'Witamy!',
  'aet.home.student.roaster.ProgressTitle': 'Całkowite ukończenie',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Sprawdź ponownie, gdy studenci rozpoczną zadanie.',
  'aet.home.whatDueThisWeekTitle': 'Oto, co należy zrobić w tym tygodniu',
  'aet.assignments.edit.errorTitle': '{count} zadania zawierają błędy',
  'aet.assignments.edit.errorSubTitle': 'Zadania zawierające błędy nie mogą zostać opublikowane. Edytuj je lub opublikuj bez nich.',
  'aet.assignments.edit.publishAnyway': 'Opublikuj mimo wszystko',
  'aet.assignments.edit.editAssignments': 'Edytuj zadania',
  'aet.assignments.edit.validationInfoToolTip': 'Edytuj zadanie, aby usunąć błędy',
  'aet.assignments.error.assignmentCreated.title': 'Wszystkie zadania zawierają błędy',
  'aet.assignments.error.assignmentCreated.description': 'Zadania zawierające błędy nie mogą zostać opublikowane. Edytuj je lub wypróbuj inny program nauczania.',
  'aet.assignments.error.uploadSyllabus': 'Prześlij sylabus',
  'aet.assignments.error.editAssignments': 'Edytuj zadania',
  'aet.mondly.title': 'Języki',
  'aet.studentRoster.errorState.title': 'Lista studentów niedostępna',
  'aet.studentRoster.errorState.description': 'Nie udało się załadować listy uczniów. Spróbuj odświeżyć stronę lub sprawdź później.',
  'aet.assignments.sectionLabel': 'sekcja(-e)',
  'aet.assignments.questionsLabel': 'pytanie(-a)',
  'aet.assignments.assignmentsLabel': 'zadanie(-a)',
  'aet.assignments.performanceProgressBar': 'Pasek postępu wydajności',
  'aet.assignments.completionProgressBar': 'Pasek postępu realizacji',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Czy na pewno chcesz usunąć to zadanie?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Czy na pewno chcesz usunąć te zadania?',
  'aet.home.nextAssignmentTitle': 'Następne zadanie',
  'aet.home.courseSettings': 'Ustawienia kursu',
  'aet.home.pearsonETextbookResources': 'Zasoby Pearson+ eTextbook',
  'aet.home.etextbookInformation': 'Informacje o eTextbook',
  'aet.multiple.deleteAssignmentKeepCTA': 'Zachowaj zadanie(-a)',
  'aet.syllabus.processingText.header': 'Organizujemy zadania związane z czytaniem przypisane do Twoich zajęć - zajmie to tylko chwilę.',
  'aet.syllabus.processingText.uploading': 'Przesyłanie Twojego dokumentu',
  'aet.syllabus.processingText.activating': 'Aktywacja komponentów sztucznej inteligencji',
  'aet.syllabus.processingText.extracting': 'Wyodrębnianie zadań związanych z czytaniem',
  'aet.syllabus.processingText.mapping': 'Mapowanie treści podręcznika',
  'aet.syllabus.processingText.finishing': 'Kończenie',
  'aet.syllabus.uploadErrorMessage': 'Upewnij się, że plik PDF lub .docx ma rozmiar poniżej 10 MB i że połączenie internetowe jest stabilne',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Spróbuj ponownie',
  'aet.syllabus.selectChapterWithQuestions': 'Wybierz rozdział z pytaniami.',
  'preferenceSetting.subTitle': 'Te ustawienia będą domyślne dla wszystkich studentów tego kursu.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interakcje z AI',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Włącz narzędzie do nauki AI i podsumowania AI w wynikach wyszukiwania',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Pokaż materiały przygotowujące do nauki związane z tą książką',
  'aet.syllabus.footer': 'Tworzenie zadań odbywa się przy pomocy AI',
  'aet.dashboard.footerDialogDeatils': 'Generatywna sztuczna inteligencja AI służy do tworzenia pytań do zadań domowych w oparciu o materiały edukacyjne Pearson. Pearson dysponuje procesem walidacji danych wyjściowych, jednak generatywna sztuczna inteligencja AI może nadal generować niedokładne informacje o ludziach, miejscach lub faktach. Sztuczna inteligencja służy również do grupowania treści w zadania na podstawie dostarczonego przez Ciebie sylabusa i/lub harmonogramu.',
  'aet.review.footer': 'Utworzono przy użyciu AI',
  'aet.footerCard.dismiss': 'Odrzuć',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Przygotowanie do nauki to dodatkowe narzędzie wspomagające naukę poprzez udostępnianie uczniom materiałów wideo i zadań praktycznych dostosowanych do potrzeb tego kursu.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Studenci, których plan dostępu nie obejmuje Przygotowania do nauki, mogą zostać poproszeni o subskrypcję w celu dalszego korzystania z tej usługi i powiązanych z nią materiałów.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Ustawienie to nie będzie miało wpływu na studentów, którzy już zakupili Przygotowanie do nauki.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Dowiedz się więcej o korzyściach płynących z programu Przygotowanie do nauki',
  'aet.home.viewCourseId': 'Wyświetl ID kursu',
  'aet.home.copy': 'Kopiuj',
  'aet.home.copied': 'Skopiowano',
  'aet.home.courseLabel': 'ID kursu:',
  'schoolInfoCard.addUniversity': '-',
  'schoolInfoCard.title': 'Informacje o szkole',
  'schoolInfoCard.titleV1': 'Opowiedz nam o swoim kursie',
  'schoolInfoCard.cta': 'Zaczynamy',
  'schoolInfoCard.pickInstitution': '-',
  'schoolInfoCard.addUniversityTitle': 'Dodaj swoją szkołę',
  'schoolInfoCard.addUniversitySubtitle': 'Znajomość Twojej szkoły i kierunku studiów pozwoli nam polecić Ci najbardziej przydatne materiały do nauki.',
  'schoolInfoCard.searchPlaceholder': 'Wyszukaj swoją szkołę...',
  'schoolInfoCard.skip': 'Pomiń ten krok',
  'schoolInfoCard.nextStep': 'Następny krok',
  'schoolInfoCard.notInList': 'Moja szkoła nie figuruje na liście',
  'schoolInfoCard.noResults': 'Nie znaleziono szkół odpowiadających Twoim kryteriom wyszukiwania',
  'schoolInfoCard.noResultsHeading': 'Nie możesz znaleźć swojej szkoły?',
  'schoolInfoCard.noResultsInstruction': 'Wpisz poniżej swoje imię i nazwisko',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nazwa szkoły',
  'schoolInfoCard.addInstitutionLabel': 'Dodaj tę szkołę',
  'aet.assignments.assignmentTitlePlaceholder': 'Wpisz tytuł',
  'aet.assignments.titleValidation.titleRequired': 'Wymagany jest tytuł zadania.',
  'aet.assignments.titleValidation.titleTooLong': 'Tytuł zadania nie może być dłuższy niż {0} znaków.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Tytuł zadania zawiera znaki, które nie są obsługiwane.',
  'aet.assignments.titleValidation.titleDuplicate': 'Tytuł zadania już istnieje',
  'aet.syllabus.timeZoneLabel': 'Strefa czasowa',
  'aet.review.reviewReadingFromAssignments': 'Przeglądaj lekturę w ramach zadania',
  'aet.assignments.chaptersLabel': '-',
  'menu.myAccount.subTitle': '-',
  'menu.myAccount.subTitleNotAvailable': '-',
  'schoolInfoCard.toastMessage': '-',
  'aet.review.threeDotMenu.askAI': 'Zadaj pytanie AI',
  'aet.home.suggestedRemediationSubtitle': '-',
  'aet.home.laggedQuestionLabel': 'Oznaczone pytania',
  'aet.home.correctAnswer': 'Poprawna odpowiedź',
  'aet.home.incorrectAnswer': 'Najczęstsze błędne odpowiedzi',
  'aet.home.behaviourTrendsLabel': 'Analiza pytania',
  'aet.home.strugglingStudentsLabel': 'Studenci z trudnościami',
  'aet.home.patternsInStudensAiLabel': 'Wzorce wykorzystania sztucznej inteligencji przez studentów',
  'aet.home.questionLabel': 'Pytanie',
  'aet.home.studentAskingSimilarQuestions': 'Studenci zadające podobne pytania:',
  'aet.home.assignmentDifficultQuestions': 'Trudne pytania',
  'aet.home.behaviorTrends': 'Analiza pytania',
  'aet.home.behaviors': 'Wskaźniki efektywności',
  'aet.home.mostDifficultTopics': '-',
  'aet.home.commentsFromStudentLabel': 'Komentarze od studentów',
  'aet.home.disregard': 'Zignoruj',
  'aet.home.reportAsInaccurate': 'Zgłoś jako nieprawidłowe',
  'aet.home.Flagged': 'Oznaczono',
  'aet.home.reportQuestionTitle': 'Zgłoś pytanie',
  'aet.home.reportQuestionLabel': 'Co było nie tak z tym pytaniem?',
  'aet.home.showComments': 'Pokaż komentarze',
  'aet.home.studentReports': 'raporty studentów',
  'aet.home.placeholderText': 'Proszę o wyjaśnienie...',
  'aet.home.reportQuestion.notRelevant': 'Nie dotyczy',
  'aet.home.reportQuestion.notCorrect': 'Niepoprawne',
  'aet.home.reportQuestion.unsafe': '-',
  'aet.home.reportQuestion.somethingElse': 'Coś innego',
  'aet.home.StudentDetails.assistedByAI': 'Wspomagane przez AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Żaden ze studentów nie ma obecnie trudności.',
  'aet.home.strugglingStudents.emptyStateDescription': 'Sprawdź później.',
  'aet.home.overallStatus.excelling': 'Doskonałe wyniki',
  'aet.home.overallStatus.fallingBehind': 'Słabe wyniki',
  'aet.home.overallStatus.keepingUp': '-',
  'aet.home.showOnlyDifficultQuestionsLabel': '-',
  'aet.home.showOnlyStrugglingStudentsLabel': '-',
  'aet.home.viewQuestionInAssignment': '-',
  'aet.home.insightRisk.incorrectFirstAttempts': '-',
  'aet.home.insightRisk.multipleIncorrectAttempts': '-',
  'aet.home.insightRisk.lowConfidence': '-',
  'aet.home.insightRisk.mediumConfidence': '-',
  'aet.home.insightRisk.lowEngagement': '-',
  'aet.home.insightRisk.countOfStudents': '-',
  'aet.home.insightRisk.na': 'Nie dotyczy',
  'aet.home.strugglingStudentsHereLabel': '-',
  'aet.home.insightRisk.didNotAttempt': '-',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default pl;
